<template>
  <img
    class="logo-gov-co"
    src="@/assets/img/logo-gov-co.png"
    alt="Gobierno de Colombia"
  />
</template>

<script>
export default {};
</script>

<style>
.logo-gov-co {
  height: 40px !important;
}
</style>
